/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Total_Txns_Name_Since_TgeInputs */



/**
* | output |
* | --- |
* | "Total Transactions (since TGE)" |
*
* @param {Metric_Total_Txns_Name_Since_TgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_total_txns_name_since_tge = /** @type {((inputs?: Metric_Total_Txns_Name_Since_TgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Total_Txns_Name_Since_TgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Total Transactions (since TGE)")
});